import _ from 'underscore';

export const getStyles = ({ searchBox = {} }, { palette = {} }) => {
  const defaultInputGroup = {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  };
  const defaultInput = {
    paddingTop: 3,
    paddingRight: 31,
    paddingBottom: 3,
    paddingLeft: 32,
    marginRight: -31,
    marginLeft: -32,
  };
  const defaultInputForHotKey = {
    paddingTop: 3,
    paddingRight: 41,
    paddingBottom: 3,
    paddingLeft: 32,
    marginRight: -41,
    marginLeft: -32,
  };
  const defaultInputForListBox = _.extend({}, defaultInput, {
    borderRadius: 0,
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    paddingRight: 30,
    marginRight: -30,
  });
  const defaultLogo = {
    fontSize: '16px',
    padding: 8,
    color: palette.neutralSecondary,
    top: 0,
  };
  const defaultIcon = {
    fontSize: '16px',
    padding: 7,
    color: palette.white,
    backgroundColor: palette.themeDark,
    cursor: 'pointer',
    borderRadius: '0px 1px 1px 0px',
    top: 0,
  };

  return {
    inputGroup: _.extend(defaultInputGroup, searchBox.inputGroup),
    input: _.extend(defaultInput, searchBox.input),
    inputForHotKey: _.extend(defaultInputForHotKey, searchBox.input),
    inputForListBox: _.extend(defaultInputForListBox, searchBox.inputForListBox),
    logo: _.extend(defaultLogo, searchBox.logo),
    icon: _.extend(defaultIcon, searchBox.icon),
  };
};
